<template>
  <div class="results-feedback-block" @click="toggleExpand">
    <div>
      <div class="results-feedback-block-interior">
        <div v-if="position === '1'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/gdss_gold.svg" />
        </div>
        <div v-else-if="position === '2'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/gdss_silver.svg" />
        </div>
        <div v-else-if="position == '3'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/gdss_bronze.svg" />
        </div>
        <div class="results-feedback-block-right">
          <b class="results-feedback-block-title">{{$t('candidate_profiles.gdss_title')}}
            <b :class="'results-feedback-block-title-top10' + getGradeColour()" v-if="top10">top 10%</b>
          </b>
          <div class="results-feedback-block-text">
            <div :class="isExpanded ? ' ' : 'results-feedback-block-text-short'">
              {{$t('candidate_profiles.gdss_text')}}
            </div>
            <div v-if="!isExpanded">
              <i class="results-feedback-block-expand">{{$t('candidate_profiles.discover_more')}}</i>
            </div>
          </div>
        </div>
        <div v-if="isExpanded">
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_up.svg" />
        </div>
        <div v-else>
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_down.svg" />
        </div>
      </div>
      <div v-if="isExpanded">
        <div class="module-laboratory">
          <div class="module-block-title">Le mot du labo</div>
          <p class="quote"><span class="quote-icon">
            </span> Savoir gérer son stress, c'est <strong>garder le contrôle de soi</strong> pour agir efficacement face à des
            situations de tension. C’est une compétence clé pour la plupart des postes où il faut savoir garder une
            approche <strong>rationnelle</strong> malgré un environnement qui peut être stressant.
            <span class="quote-icon end"></span>
          </p>
        </div>
        <div class="module-advantages">
          <div class="module-block-title"> Les avantages de la gestion du stress </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon increase-square"></i></div>
              <div class="description">Maintenir ses performances en situation de stress</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon flash"></i></div>
              <div class="description">Être à l’aise dans des situations de tension</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon warning-triangle"></i></div>
              <div class="description">Savoir travailler sous contrainte</div>
            </div>
          </div>
        </div>
        <div class="module-advices">
          <div class="module-block-title"> Comment améliorer votre gestion du stress </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon people"></i></div>
              <div class="description">Partager sa situation avec ses collaborateurs et sa hiérarchie</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon sun-cloud"></i></div>
              <div class="description">Repousser sa zone de confort afin de s’acclimater aux situations de tension</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['position', 'top10'],
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getGradeColour() {
      var iconClass = " ";
      switch (this.position) {
        case '1':
          iconClass += "or-gradient";
          break;
        case '2':
          iconClass += "argent-gradient";
          break;
        case '3':
          iconClass += "bronze-gradient";
          break;
        default:
          break;
      }
      return iconClass;
    }
  }
};
</script>
